const METRICS = [
  { num: "<60 days", cap: "Idea to production for your first agentic application" },
  { num: "70%", pre: "up to", cap: "Routine business execution shifted to AI agents" },
  { num: ">95%", cap: "Assured agentic workflow precision" },
  { num: "30%", pre: "up to", cap: "Operating costs slashed with an agentic workforce" },
  { num: "3\u20135\u00D7", cap: "Faster rollout of subsequent agentic AI use cases" },
];

const PILLARS = [
  { k: "Speed", v: "AI value in days, not years" },
  { k: "Scale", v: "Agentic workflows across functions, not silos" },
  { k: "Sustenance", v: "Self-healing operations with predictable AI economics" },
];

const Label = ({ children }) => (
  <div className="bg-[#211307] text-[#EDA13A] font-mono2 text-xs uppercase tracking-[0.28em] px-6 py-3">{children}</div>
);

// ---------- OPTION A: Dark metric ticker band ----------
export const CommitmentsA = () => (
  <section className="bg-[#211307] text-[#F7F5F0] py-16 lg:py-20" data-testid="commit-a">
    <div className="max-w-7xl mx-auto px-6 sm:px-8">
      <h2 className="font-display font-medium tracking-tight text-2xl sm:text-3xl lg:text-[2.5rem] leading-[1.12] max-w-3xl">
        <span className="text-[#F7F5F0]/45">STOP</span> spending on AI experiments.<br />
        <span className="text-[#EDA13A]">START</span> achieving AI outcomes.
      </h2>
      <div className="mt-12 grid grid-cols-2 md:grid-cols-5 gap-8 border-t border-white/10 pt-9">
        {METRICS.map((m) => (
          <div key={m.cap}>
            {m.pre && <span className="block text-[10px] uppercase tracking-widest text-white/40 mb-1">{m.pre}</span>}
            <div className="font-display font-medium text-3xl lg:text-[2.5rem] leading-none text-[#EDA13A]">{m.num}</div>
            <p className="mt-3 text-xs text-white/60 leading-snug">{m.cap}</p>
          </div>
        ))}
      </div>
      <div className="mt-11 grid grid-cols-1 md:grid-cols-3 gap-6 border-t border-white/10 pt-8">
        {PILLARS.map((p) => (
          <div key={p.k}>
            <div className="font-mono2 text-xs uppercase tracking-[0.22em] text-[#E8AA68]">{p.k}</div>
            <p className="mt-2 text-sm text-white/70 leading-snug">{p.v}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// ---------- OPTION B: Light split layout ----------
export const CommitmentsB = () => (
  <section className="bg-[#F7F5F0] text-[#3E2818] py-16 lg:py-20" data-testid="commit-b">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
      <div>
        <h2 className="font-display font-medium tracking-tight text-2xl sm:text-3xl lg:text-[2.5rem] leading-[1.12]">
          <span className="text-[#3E2818]/40">STOP</span> spending on AI experiments. <span className="text-[#8A5730]">START</span> achieving AI outcomes.
        </h2>
        <div className="mt-9 space-y-5 border-t border-[#3E2818]/10 pt-7">
          {PILLARS.map((p) => (
            <div key={p.k} className="flex gap-4">
              <div className="font-mono2 text-xs uppercase tracking-[0.22em] text-[#8A5730] w-28 shrink-0 pt-0.5">{p.k}</div>
              <p className="text-sm text-[#3E2818]/70 leading-snug">{p.v}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-x-8 gap-y-9">
        {METRICS.map((m) => (
          <div key={m.cap}>
            {m.pre && <span className="block text-[10px] uppercase tracking-widest text-[#8A5730]/70 mb-1">{m.pre}</span>}
            <div className="font-display font-medium text-3xl lg:text-[2.75rem] leading-none text-[#8A5730]">{m.num}</div>
            <p className="mt-3 text-xs text-[#3E2818]/60 leading-snug">{m.cap}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// ---------- OPTION C: Minimal inline strip ----------
export const CommitmentsC = () => (
  <section className="bg-[#EFE7D9] text-[#3E2818] py-14" data-testid="commit-c">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 text-center">
      <h2 className="font-display font-medium tracking-tight text-xl sm:text-2xl lg:text-[2rem] leading-[1.15] max-w-3xl mx-auto">
        <span className="text-[#3E2818]/40">STOP</span> spending on AI experiments. <span className="text-[#8A5730]">START</span> achieving AI outcomes.
      </h2>
      <div className="mt-9 flex flex-wrap justify-center gap-y-6">
        {METRICS.map((m, i) => (
          <div key={m.cap} className={`px-6 sm:px-8 ${i !== 0 ? "border-l border-[#3E2818]/15" : ""}`}>
            <div className="font-display font-medium text-2xl lg:text-3xl leading-none text-[#8A5730]">{m.num}</div>
            <p className="mt-2 text-[11px] text-[#3E2818]/60 leading-snug max-w-[9rem]">{m.cap}</p>
          </div>
        ))}
      </div>
      <p className="mt-9 text-xs text-[#3E2818]/60">
        {PILLARS.map((p, i) => (
          <span key={p.k}>
            {i !== 0 && <span className="mx-3 text-[#3E2818]/25">/</span>}
            <span className="font-mono2 uppercase tracking-[0.18em] text-[#8A5730]">{p.k}</span>
            <span className="ml-2">{p.v}</span>
          </span>
        ))}
      </p>
    </div>
  </section>
);

export default function CommitmentsPreview() {
  return (
    <div>
      <Label>Option A — Dark Metric Ticker</Label>
      <CommitmentsA />
      <Label>Option B — Light Split Layout</Label>
      <CommitmentsB />
      <Label>Option C — Minimal Inline Strip</Label>
      <CommitmentsC />
    </div>
  );
}
